import {useReducer, useEffect} from 'react';
import {getDateDiff, TimeInSeconds} from '../../shared/utils/DateUtils';
import {formatRelativeTime} from '../utils/Utils';

interface State {
    expired: boolean;
    count: number;
    intervalId?: number;
    timestamp: string;
}

interface Action {
    type: 'tick';
}

export const useCountdown = (
    messages: Record<string, string>,
    expireDate: string,
    expired = false
): State => {
    const [state, dispatch] = useReducer(
        (state: State, action: Action): State => {
            switch (action.type) {
                case 'tick': {
                    const diffInSeconds = getDateDiff(Date.now(), expireDate, TimeInSeconds.SECOND);

                    const expired = diffInSeconds <= 0;
                    if (expired) {
                        clearInterval(state.intervalId);
                    }

                    return {
                        ...state,
                        expired,
                        count: state.count + 1,
                        timestamp: formatRelativeTime(messages, expireDate, true)
                    };
                }
                default: {
                    return state;
                }
            }
        },
        {},
        state => {
            return {
                expired,
                count: 0,
                intervalId: !expired && setInterval(() => dispatch({type: 'tick'}), 1000),
                timestamp: null
            };
        }
    );

    useEffect(() => {
        return () => clearInterval(state.intervalId);
    }, [dispatch]);

    return state;
};

export default useCountdown;
